import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import XRefreshToken from "@/js/Components/XRefreshToken.vue";

function handleError(event, app) {
    if (!Array.isArray(event?.errors)) return true;

    for (const error of event.errors) {

        if (error?.errorClass === 'AxiosError') {
            return false;
        }

        if (
            error?.errorClass === 'RangeError' &&
            error.errorMessage?.includes('Maximum call stack size exceeded') &&
            (
                !error.stacktrace ||
                error.stacktrace.every(f =>
                    !f.file ||
                    f.file === 'unknown' ||
                    f.file.startsWith('undefined')
                )
            )
        ) {
            return false;
        }

        if (error?.errorClass === 'InvalidError'
            && error?.message?.error?.errorMessage
            && error.message.error.errorMessage.includes('unhandledrejection handler received a non-error. See "unhandledrejection handler" tab for more detail.')) {
            return false;
        }

        if (
            error?.errorMessage &&
            (
                error.errorMessage.includes('Unable to preload CSS for') ||
                error.errorMessage.includes('Failed to fetch dynamically imported module')
            )
        ) {
            app.config.globalProperties.$modal(XRefreshToken, {
                id: 'x-refresh-token'
            });

            return false;
        }
    }

    return true;
}

export default {
    install(app, options = {}) {
        app.config.warnHandler = (msg, instance, trace) => {
            if (msg.includes('Runtime directive used on component with non-element root node')) {
                return;
            }

            if(msg.includes('Extraneous non-props attributes (class, style)')) {
                return;
            }

            console.warn(msg + trace);
        };


        if (options.bugsnagKey) {
            Bugsnag.start({
                apiKey: options.bugsnagKey,
                plugins: [new BugsnagPluginVue()],
                onError: (event) => {
                    return handleError(event, app);
                }
            });

            app.mixin({
                mounted() {
                    if (this.$options.__name !== 'App') return;

                    const store = app.config.globalProperties.$store;
                    const user = store.getters['auth/user'];

                    Bugsnag.addMetadata('user', {
                        id: user?.id,
                        email: user?.email,
                        prev:  store.getters['auth/prev'],
                    });

                    Bugsnag.addMetadata('app', {
                        version: window.setup?.version,
                        build: window.setup?.build,
                    });

                    app.config.globalProperties.$router.afterEach((to, from) => {
                        Bugsnag.addMetadata('route', {
                            to: to.name,
                            to_path: to.fullPath,
                            from: from.name,
                            from_path: from.fullPath
                        });
                    })
                }
            });

            app.use(Bugsnag.getPlugin('vue'));
            return;
        }

        // to catch global errors
        window.addEventListener("error", (event) => {
            handleError(event);
        }, true);

        // To catch promise unhandled rejections
        window.addEventListener("unhandledrejection", (event) => {
            let error = event.reason;
            if (!(error instanceof Error)) {
                error = new Error(typeof error === "string" ? error : JSON.stringify(error));
            }
            handleError({
                errors: [{ errorMessage: error.message }]
            }, app);
        });

        // To catch other errors
        app.config.errorHandler = (error, instance, info) => {
            handleError({
                errors: [{ errorMessage: error.message }]
            }, app);
            return true;
        }
    }
}